import useJwt from "@/auth/jwt/useJwt";

export const GetLastBookingOfVanCont = async (data) => {
  const result = await useJwt.get("wr1?objectType=GetLastBookingOfVanCont", {
    params: {
      search: {
        ...data,
      },
    },
  });
  return result?.data.result;
};

export const GetBookingDetail = async (data) => {
  const result = await useJwt.get("wr1?objectType=GetBookingDetail", {
    params: {
      search: {
        ...data,
      },
    },
  });
  return result?.data?.result;
};

export const UpdateStatusBooking = async (id) => {
  const result = await useJwt.put("wr1?objectType=ReceivedBookingRequest", {
    id,
  });
  return result?.data?.result;
};
export const CustomerBooking = async (id) => {
  const result = await useJwt.put("wr1?objectType=CustomerBooking", {
    id,
  });
  return result?.data?.result;
};


export const ReceivedReviseRequest = async (id) => {
  const result = await useJwt.put("wr1?objectType=ReceivedReviseRequest", {
    id,
  });
  return result?.data;
};
export const ReleaseBooking = async (id) => {
  const result = await useJwt.put("wr1?objectType=ReleaseBooking", {
    id,
  });
  return result?.data;
};


